import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    ButtonGroup,
    Paper,
    Stack,
    Tooltip,
    TooltipProps,
    Typography,
    tooltipClasses,
} from "@mui/material";
import React from "react";
import styles from "../../../../../styles/pages/user/content-buyer-purchasevideotype.module.scss";
import VideoFeaturedButtons from "../../../../../components/VideoFeaturedButtons/VideoFeaturedButtons";
import assest from "../../../../../json/assest";
// import Image from "next/image";
import MessageLineIcon from "../../../../../ui/Icons/MessageLineIcon";
import DownloadVideoIcon from "../../../../../ui/Icons/DownloadVideoIcon";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import SolidCrrossIcon from "../../../../../ui/Icons/SolidCrrossIcon";
import MinimizeIcon from "../../../../../ui/Icons/MinimizeIcon";
import ExpandMoreIcon from "../../../../../ui/Icons/ExpandMoreIcon";
import NoteIcon from "../../../../../ui/Icons/NoteIcon";
import { styled } from "@mui/system";
import CopyIcon from "../../../../../ui/Icons/CopyIcon";
import MediaFileIcon from "../../../../../ui/Icons/MediaFileIcon";
import DownloadStyledIcon from "../../../../../ui/Icons/DownloadStyledIcon";
import ViewIcon from "../../../../../ui/Icons/ViewIcon";
import VideoUrlIcon from "../../../../../ui/Icons/VideoUrlIcon";
import FileAttachIcon from "../../../../../ui/Icons/FileAttachIcon";
import PurchaseAgreementIcon from "../../../../../ui/Icons/PurchaseAgreementIcon";
import CalenderGrayIcon from "../../../../../ui/Icons/CalenderGrayIcon";
import RedTrashIcon from "../../../../../ui/Icons/RedTrashIcon";
import ReadIcon from "../../../../../ui/Icons/ReadIcon";
import ModalWrapperMd from "../../../../../ui/ModalWrapper/User/ModalWrapperMd";
import ContentbuyerVideotypeModal from "../../../../../ui/Modal/ContentbuyerVideotypeModal";
import ContentbuyerVideoFeatured from "../../../../../components/ContentbuyerVideoFeatured/ContentbuyerVideoFeatured";

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#FFFFFF',
        width: '100%',
        maxWidth: 237,
        borderRadius: '5px',
        padding: '8.5px 11px',
        boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.25)',
        [`& .MuiTypography-body1`]: {
            fontWeight: '500',
            fontSize: '12px',
            color: '#000',
            lineHeight: '14px',
            textAlign: 'center'
        }
    },
}));

const VideoType = () => {
    const [expanded, setExpanded] = React.useState(false);

    const handleChange =
        (panel) => (event, isExpanded) => {
            setExpanded(isExpanded ? panel : false);
        };

    const [openProceed, setOpenProceed] = React.useState(false);
    const handleClickOpenProceed = () => {
        setOpenProceed(true);
    };
    const handleCloseProceed = () => {
        setOpenProceed(false);
    };
    return (
        <>
            <Box className={styles.pageCopyVideo}>
                <PerfectScrollbar>
                    <Stack
                        direction={"row"}
                        flexWrap={"wrap"}
                        className={styles.copywritterVideoWrapper}
                    >
                        <Box className={styles.videoColLeft}>
                            <Paper className={styles.vdoCard}>
                                <Box className={styles.videoBox} onClick={handleClickOpenProceed}>
                                    <img src={assest.videoImage} width={701} height={435} alt="" />
                                    <ContentbuyerVideoFeatured />
                                </Box>
                                <Box className={styles.videoInput}>
                                    <input
                                        type="text"
                                        placeholder="https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOV"
                                    />
                                    <Button>
                                        <CopyIcon />
                                    </Button>
                                </Box>
                                <Stack
                                    direction={"row"}
                                    justifyContent={"space-between"}
                                    flexWrap={"wrap"}
                                    className={styles.vdobtnGrp}
                                >
                                    <Box className={styles.btnFristgrp}>
                                        <Button
                                            className={styles.msgcopyBtn}
                                            startIcon={<MessageLineIcon />}
                                        >
                                            Message Admin
                                        </Button>
                                        <Button
                                            className={styles.msgcopyBtn}
                                            startIcon={<MessageLineIcon />}
                                        >
                                            Message QC Agent
                                        </Button>
                                        <Button
                                            className={styles.msgcopyBtn}
                                            startIcon={<MessageLineIcon />}
                                        >
                                            Message Manager
                                        </Button>
                                    </Box>
                                    <Button
                                        className={styles.vdoDwnldBtn}
                                        startIcon={<DownloadVideoIcon />}
                                    >
                                        Download Video
                                    </Button>
                                </Stack>
                            </Paper>
                            <Box className={`${styles.accItems} ${styles.noteSec}`}>
                                <Accordion
                                    expanded={expanded === "myNote"}
                                    onChange={handleChange("myNote")}
                                >
                                    <AccordionSummary
                                        expandIcon={
                                            expanded === "myNote" ? <MinimizeIcon /> : <ExpandMoreIcon />
                                        }
                                        aria-controls="myNotebh-content"
                                        id="myNotebh-header"
                                    >
                                        <Typography variant="h2"><span>My Note</span></Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} flexWrap={'wrap'} className={styles.noteBtngrp}>
                                            <Button startIcon={<NoteIcon />}>Leave a note for the team</Button>
                                        </Stack>
                                        <Box className={styles.showNote}>
                                            <Box className={styles.readNote}>
                                                <Typography variant="body1">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, toSed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, tdsmohas hfdibnf,d hgbdflk,mdffdo...</Typography>
                                                <Stack direction={'row'} flexWrap={'wrap'} alignItems={'center'} justifyContent={'space-between'} className={styles.noteBottmSec}>
                                                    <Box className={styles.noteDate}>
                                                        <CalenderGrayIcon />
                                                        <Typography variant="caption">January 25, 2023</Typography>
                                                    </Box>
                                                    <Stack direction={'row'} alignItems={'center'} className={styles.btnGrpStyled}>
                                                        <Button className={styles.btndlt}><RedTrashIcon /> Delete</Button>
                                                        <Button><ReadIcon /> Read</Button>
                                                    </Stack>
                                                </Stack>
                                            </Box>
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>
                            </Box>
                        </Box>
                        <Box className={styles.videoColRight}>
                            <Paper className={`${styles.comWhiteBox} ${styles.titlePaperBox}`}>
                                <Box className={styles.paperHeading}>
                                    <Typography variant="h2">
                                        <span>Owner Details</span>
                                    </Typography>
                                    <Button>
                                        <SolidCrrossIcon />
                                    </Button>
                                </Box>
                                <Stack direction={'row'} flexWrap={'wrap'} className={styles.ownerDetailsGrid}>
                                    <Box className={`${styles.gridCol1} ${styles.Col}`}>
                                        <Box className={styles.formGroup}>
                                            <Typography variant="h6">Full Name</Typography>
                                            <Typography variant="body2">Saimon Jhonson</Typography>
                                        </Box>
                                        <Box className={styles.formGroup}>
                                            <Typography variant="h6">Phone Number</Typography>
                                            <Typography variant="body2">+1 234 567 8290</Typography>
                                        </Box>
                                    </Box>
                                    <Box className={`${styles.gridCol2} ${styles.Col}`}>
                                        <Box className={styles.formGroup}>
                                            <Typography variant="h6">Email Address</Typography>
                                            <Typography variant="body2" className={styles.mailAdd}>jognsmith@gmail.com</Typography>
                                        </Box>
                                        <Box className={styles.formGroup}>
                                            <Typography variant="h6">Social Media Handles</Typography>
                                            <Typography variant="body2">Saimon Jhonson</Typography>
                                        </Box>
                                    </Box>
                                    <Box className={`${styles.gridCol3} ${styles.Col}`}>
                                        <Box className={styles.formGroup}>
                                            <Typography variant="h6">Date of Birth</Typography>
                                            <Typography variant="body2">March 20, 1993</Typography>
                                        </Box>
                                        <Stack direction={'row'} alignItems={'flex-start'} flexWrap={'wrap'} className={styles.ownerMedia}>
                                            <Box className={styles.mediaLeft}>
                                                <MediaFileIcon />
                                            </Box>
                                            <Box className={styles.mediaRight}>
                                                <Typography variant="h5">Saimon Jhonson</Typography>
                                                <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                    <Typography variant="caption">PDF</Typography>
                                                    <ButtonGroup>
                                                        <HtmlTooltip title={
                                                            <React.Fragment>
                                                                <Typography variant="body1">Download Document</Typography>
                                                            </React.Fragment>
                                                        }>
                                                            <Button><DownloadStyledIcon /></Button>
                                                        </HtmlTooltip>
                                                        <HtmlTooltip title={
                                                            <React.Fragment>
                                                                <Typography variant="body1">Open Document</Typography>
                                                            </React.Fragment>
                                                        }>
                                                            <Button className={styles.viewFiles}><ViewIcon /></Button>
                                                        </HtmlTooltip>
                                                    </ButtonGroup>
                                                </Stack>
                                            </Box>
                                        </Stack>
                                    </Box>
                                </Stack>
                            </Paper>
                            <Paper className={`${styles.comWhiteBox} ${styles.titlePaperBox} ${styles.vdoDetailsCard}`}>
                                <Box className={styles.paperHeading}>
                                    <Typography variant="h2">
                                        <span>Video Details</span>
                                    </Typography>
                                </Box>
                                <Box className={styles.vdodetailInner}>
                                    <Box className={styles.vdoUrlGroup}>
                                        <Typography variant="caption" className={styles.formLabel}>Public Video URL</Typography>
                                        <Box className={styles.videoInput}>
                                            <input
                                                type="text"
                                                placeholder="Https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOV"
                                            />
                                            <Button>
                                                <CopyIcon />
                                            </Button>
                                        </Box>
                                    </Box>
                                    <Box className={styles.titleGroup}>
                                        <Typography variant="caption" className={styles.formLabel}>Title</Typography>
                                        <Typography variant="body2" className={styles.formPara}>Boy Jumped with the Umbrella and the Wind Almost Sent Him Flying Too Far Away</Typography>
                                    </Box>
                                    <Box className={styles.descriptionGroup}>
                                        <Typography variant="caption" className={styles.formLabel}>Description:</Typography>
                                        <Typography variant="body2" className={styles.formPara}>Fusce eget lacus non turpis porttitor gravida sit amet quis tellus. Morbi tempus finibus elit in ultrices. Nunc sagittis purus nisl, eu elementum risus faucibus vitae.</Typography>
                                        <Typography variant="body2" className={styles.formPara}>Integmolestie, ex sit amet semd mauris odimolestie, met semd mauris odimolestie, ex sit amet semd maurier molestie, ex sit amet semd mauris odidgfgo...</Typography>
                                    </Box>
                                    <Stack direction={'row'} alignItems={'center'} className={styles.filmingGrid}>
                                        <Box className={`${styles.filmingLocaton} ${styles.Col}`}>
                                            <Typography variant="caption" className={styles.formLabel}>Filming Location</Typography>
                                            <Typography variant="body2" className={styles.formPara}>Los Angeles, California, United States</Typography>
                                        </Box>
                                        <Box className={`${styles.filmingDate} ${styles.Col}`}>
                                            <Typography variant="caption" className={styles.formLabel}>Filming Date</Typography>
                                            <Typography variant="body2" className={styles.formPara}>January 25, 2019</Typography>
                                        </Box>
                                    </Stack>
                                </Box>
                                <Box className={styles.mediaFilebtn}>
                                    <Button startIcon={<VideoUrlIcon />}>Add original video file (VS Link)</Button>
                                </Box>
                                <Box className={styles.mediaFilebtn}>
                                    <Button startIcon={<FileAttachIcon />}>Add social media post URL</Button>
                                </Box>
                            </Paper>
                            <Paper className={`${styles.comWhiteBox} ${styles.titlePaperBox} ${styles.purchaseInfo}`}>
                                <Box className={styles.paperHeading}>
                                    <Typography variant="h2">
                                        <span>Purchase Information</span>
                                    </Typography>
                                </Box>
                                <Stack direction={'row'} flexWrap={'wrap'} className={styles.ownerDetailsGrid}>
                                    <Box className={`${styles.gridItem1} ${styles.Col}`}>
                                        <Box className={styles.formGroup}>
                                            <Typography variant="h6">Asset purchase agreement</Typography>
                                            <Typography variant="body2">Successfully Signed</Typography>
                                        </Box>
                                        <Box className={styles.formGroup}>
                                            <Typography variant="h6">User IP address</Typography>
                                            <Typography variant="body2">17.172.224.47</Typography>
                                        </Box>
                                    </Box>
                                    <Box className={`${styles.gridItem2} ${styles.Col}`}>
                                        <Box className={styles.formGroup}>
                                            <Typography variant="h6">Terms of Service</Typography>
                                            <Typography variant="body2" className={styles.mailAdd}>Agreed</Typography>
                                        </Box>
                                        <Box className={styles.formGroup}>
                                            <Typography variant="h6">Country</Typography>
                                            <Typography variant="body2">United States</Typography>
                                        </Box>
                                    </Box>
                                    <Box className={`${styles.gridItem3} ${styles.Col}`}>
                                        <Box className={styles.formGroup}>
                                            <Typography variant="h6">Purchase date</Typography>
                                            <Typography variant="body2">August 23, 2021 at 11:15:34 PM UTC</Typography>
                                        </Box>
                                        <Box className={styles.formGroup}>
                                            <Typography variant="h6">Pre-approved flat fee:</Typography>
                                            <Typography variant="body2">$70</Typography>
                                        </Box>
                                    </Box>
                                    <Box className={`${styles.gridItem4} ${styles.Col}`}>
                                        <Box className={styles.formGroup}>
                                            <Typography variant="h6">VSID</Typography>
                                            <Typography variant="body2">17171</Typography>
                                        </Box>
                                        <Box className={`${styles.formGroup} ${styles.purchaseBtn}`}>
                                            <Button
                                                className={styles.vdoDwnldBtn}
                                                startIcon={<PurchaseAgreementIcon />}
                                            >
                                                Purchase Agreement
                                            </Button>
                                        </Box>
                                    </Box>
                                </Stack>
                            </Paper>
                            <Box className={`${styles.accItems} ${styles.noteSec} ${styles.teamMsg}`}>
                                <Accordion
                                    expanded={expanded === "TeamMessages"}
                                    onChange={handleChange("TeamMessages")}
                                >
                                    <AccordionSummary
                                        expandIcon={
                                            expanded === "TeamMessages" ? <MinimizeIcon /> : <ExpandMoreIcon />
                                        }
                                        aria-controls="TeamMessagesbh-content"
                                        id="TeamMessagesbh-header"
                                    >
                                        <Typography variant="h2" sx={{ width: '35%', flexShrink: 0 }}><span>Team Messages</span></Typography>
                                        <Stack direction={'row'} alignItems={'center'} className={styles.teambtnGroup}>
                                            <Button>Admin</Button>
                                            <Button>Manager</Button>
                                            <Button>QC Agent</Button>
                                        </Stack>
                                    </AccordionSummary>
                                </Accordion>
                            </Box>
                        </Box>
                    </Stack>
                </PerfectScrollbar>
            </Box>

            <ModalWrapperMd open={openProceed} onClose={handleCloseProceed} handleClose={handleCloseProceed}>
                <ContentbuyerVideotypeModal />
            </ModalWrapperMd>
        </>

    );
};

export default VideoType;
